import React, { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import {
  Button as CommonButton,
  surveyType,
  getAssessmentCompareRoutePrefix,
} from '@abroad/components'

const AssessmentCommonButton = ({ selectedSurveys }) => {
  const [isCompareBtnDisabled, setIsCompareBtnDisabled] = useState(
    selectedSurveys?.length !== 2,
  )
  const { clientId } = useParams()
  const history = useHistory()

  useEffect(() => {
    if (selectedSurveys?.length !== 2) {
      setIsCompareBtnDisabled(true)
      return
    }
    const isSameTypeOfSurvey = selectedSurveys
      .map((survey) => survey?.surveyType)
      .every((val, i, arr) => val === arr[0])
    setIsCompareBtnDisabled(!isSameTypeOfSurvey)
  }, [selectedSurveys])

  return (
    <CommonButton
      variant='gray'
      className='text-uppercase ml-2 line-height-normal border-radius-3'
      onClick={() => {
        if (!isCompareBtnDisabled) {
          const compareSurveyType =
            selectedSurveys[1]?.surveyType === surveyType.WISDOM
              ? surveyType.WISDOM
              : selectedSurveys[1]?.surveyType === surveyType.PROSPERITY
              ? surveyType.PROSPERITY
              : surveyType.AWARENESS

          if (compareSurveyType === surveyType.WISDOM) {
            history.push(
              `/user/${clientId}/comparison_report?survey=${selectedSurveys[0]?.id}&survey=${selectedSurveys[1]?.id}&surveyType=${compareSurveyType}`,
            )
            return
          }

          const routePrefix = getAssessmentCompareRoutePrefix(compareSurveyType)
          history.push(
            `/${routePrefix}/comparison-report?survey=${selectedSurveys[0]?.id}&survey=${selectedSurveys[1]?.id}&surveyType=${compareSurveyType}&clientId=${clientId}`,
          )
        }
      }}
      disabled={isCompareBtnDisabled}>
      Compare Assessments
    </CommonButton>
  )
}

export default AssessmentCommonButton
